import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState, useEffect, createContext } from "react";
import { CookiesProvider } from "react-cookie";
import TokenManager from "./components/shared/TokenManager";
import NavigationModern from "./components/features/navigation/components/BottomNavigation";
import ComplexNavbar from "./components/features/navigation/components/DesktopNavigation";
import Mapbox from "./pages/MapboxPage";
//Context

// Google Analytics
import ReactGA from "react-ga";

// Pages
import Home from "./pages/HomePage";
import Contact from "./pages/ContactPage";
import Profiles from "./components/features/user/components/profile/ProfileView";

// Edit
import EditProfile from "./components/features/user/components/profile/ProfileEditForm";
import EditHouse from "./components/features/properties/components/forms/EditHouseForm";
import EditCondo from "./components/features/properties/components/forms/EditCondoForm";
import EditCommercial from "./components/features/properties/components/forms/EditCommercialForm";
import EditLand from "./components/features/properties/components/forms/EditLandForm";

import EditLead from "./components/features/user/components/posts/EditLead";
//Auth
import RegisterNew from "./components/features/auth/components/RegisterForm";
import ResetPassword from "./components/features/auth/components/PasswordResetForm";

//Profiles
import InviteFriend from "./components/features/user/components/referrals/InviteFriends";
import Point_commission from "./components/features/user/components/commission/CommissionDashboard";
import WithDrawMoney from "./components/features/user/components/commission/WithdrawalForm";
import BanksChoose_PointCommission from "./components/features/user/components/commission/BankAccountForm";
import HistoryCommission from "./components/features/user/components/commission/CommissionHistory";
import MembersLayer from "./components/features/user/components/referrals/MemberHierarchy";
import MembersLayerData from "./components/features/user/components/referrals/MemberHierarchyDetail";
import MyPost from "./components/features/user/components/posts/MyPosts";

//Product
import ViewProduct from "./components/features/properties/components/display/PropertyDetail";

//Real Estate
import SelectPostType from "./components/features/properties/components/forms/PropertyTypeSelector";
import SelectPostAssets from "./components/features/properties/components/forms/SelectPostAssets";
import LeadAssets from "./components/features/user/components/posts/LeadAssets";
import CreateHouse from "./components/features/properties/components/forms/HouseForm";
import CreateCondo from "./components/features/properties/components/forms/CondoForm";
import CreateLand from "./components/features/properties/components/forms/LandForm";
import CreateCommercial from "./components/features/properties/components/forms/CommercialForm";
import CreateTownHouse from "./components/features/properties/components/forms/TownhouseForm";
import EditTownHouse from "./components/features/properties/components/forms/EditTownhouseForm";
import CreateOtherPost from "./components/features/properties/components/forms/OtherForm";
//Other
import CartSystem from "./components/features/cart/CartPage";
import Logout from "./components/features/auth/components/LogoutButton";
import JoinTeam from "./pages/JoinTeamPage";
import Mylead from "./components/features/user/components/posts/MyLeads";
import MyShareAsset from "./components/features/user/components/posts/SharedProperties";
import Settings from "./components/features/user/components/profile/ProfileSettings";
import LandingPage from "./pages/LandingPage";

//Compare Assets
import HelpSellPostperty from "./components/features/properties/components/shared/HelpSellPostperty";

// Notifications
import NotificationFront from "./components/features/notifications/NotificationPage";
import DetailMessageInbox from "./components/features/notifications/MessageDetail";
import BleDataDisplay from "./components/features/properties/components/display/TestBLE";
import { LoginSystem } from "./components/features/auth/components/LoginForm";
import TestMap from "./components/features/maps/components/TestMap";
import RealEstateCreatePosts from "./components/features/properties/components/forms/RealEstateCreatePosts";
import AunityRedirect from "./pages/AunityRedirectPage";
import ContactCustomerAsset from "./components/contact_customer/asset";
//Context Controllers
export const MyContextMapAndGrid = createContext();
export const ControlStateGMapAndGrid = ({ children }) => {
  const [statusCloseMap, SetStatusCloseMap] = useState(false);
  const [statusCloseGrid, setStatusCloseGrid] = useState(false);
  const [statusHalfGridMap, setStatusHalfGridMap] = useState(true);
  const [isFullMapButtonOn, setIsFullMapButtonOn] = useState(false);
  const [isFullGridButtonOn, setIsFullGridButtonOn] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [dataSearchValue, setDataSearchValue] = useState([]);
  const [dataDisplay, setDataDisplay] = useState([]);
  
  return (
    <MyContextMapAndGrid.Provider
      value={{
        statusCloseMap,
        SetStatusCloseMap,
        statusCloseGrid,
        setStatusCloseGrid,
        statusHalfGridMap,
        setStatusHalfGridMap,
        isFullMapButtonOn,
        setIsFullMapButtonOn,
        isFullGridButtonOn,
        setIsFullGridButtonOn,
        searchValue,
        setSearchValue,
        dataSearchValue,
        setDataSearchValue,
        dataDisplay,
        setDataDisplay,
      }}
    >
      {children}
    </MyContextMapAndGrid.Provider>
  );
};

export const GalleryContext = createContext();

export const GalleryProvider = ({children}) =>{
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [isClickContactModalDetail ,setIsClickContactModalDetail] = useState(false)
  return(
    <GalleryContext.Provider value={{isGalleryOpen , setIsGalleryOpen }}>
      {children}
    </GalleryContext.Provider>
  )
}
function App() {
  // Google Analytics
  // Initialize Google Analytics
  ReactGA.initialize("G-NRRJP2GK4T");

  // This will log page views as users navigate through your app
  ReactGA.pageview(window.location.pathname + window.location.search);

  const [showDesktop, setShowDesktop] = useState(false);
  const [showMobileNav, setShowMobileNav] = useState(false);
  const [hiddenNav, setHiddenNav] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 822) {
        setShowDesktop(true);
      } else {
        setShowDesktop(false);
      }

      if (window.innerWidth < 821) {
        setShowMobileNav(true);
      } else {
        setShowMobileNav(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScrollTop > lastScrollTop) {
        // User is scrolling down
        setHiddenNav(true);
      }
      if (currentScrollTop < lastScrollTop) {
        setHiddenNav(false);
      }

      setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  return (
    <div className="App">
      <ControlStateGMapAndGrid>
        <GalleryProvider>
        <CookiesProvider>
          <Router>
            <TokenManager>
            {showMobileNav && !hiddenNav && (
              // <div className="animate-moveDownSmooth">
              <NavigationModern />
              // </div>
            )}
            {showDesktop && <ComplexNavbar />}
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/home" element={<Home />} />
              <Route path="/home/:id" element={<ViewProduct />} />
              <Route path="/ble" element={<BleDataDisplay />} />
              <Route path="/testmap" element={<TestMap />} />

              <Route path="/contact" element={<Contact />} />
              <Route path="/jointeam" element={<JoinTeam />} />
              <Route path="/mapbox" element={<Mapbox />} />

              <Route path="/product/:id" element={<ViewProduct />} />

              <Route path="/login" element={<LoginSystem />} />
              <Route path="/register" element={<RegisterNew />} />
              <Route path="/reset_password" element={<ResetPassword />} />

              {/* profile sections */}
              <Route path="/profiles" element={<Profiles />} />
              <Route path="/user/point" element={<Point_commission />} />
              <Route
                path="/user/point/bank"
                element={<BanksChoose_PointCommission />}
              />
              <Route path="/user/point/withdraw" element={<WithDrawMoney />} />
              <Route
                path="/user/point/history"
                element={<HistoryCommission />}
              />

              <Route path="/reference/invite" element={<InviteFriend />} />
              <Route path="/members/layer" element={<MembersLayer />} />
              <Route
                path="/members/layer/desc"
                element={<MembersLayerData />}
              />

              <Route path="/profile/mypost" element={<MyPost />} />
              <Route path="/profile/mylead" element={<Mylead />} />
              <Route path="/profile/myshare" element={<MyShareAsset />} />
              <Route path="/profile/settings" element={<Settings />} />

              <Route path="/editprofile" element={<EditProfile />} />
              <Route path="/cart" element={<CartSystem />} />

              {/* MatchPeople */}

              <Route path="/logout" element={<Logout />} />
              {/* <Route path="/edit/lead" */}
              <Route path="/edit/lead/:id" element={<EditLead />} />

              {/* Notification */}
              <Route path="/noti" element={<NotificationFront />} />
              <Route path="/noti/:messageID" element={<DetailMessageInbox />} />


              {/* Real Essate */}
              <Route
                path="/create/real_estate/:type"
                element={<RealEstateCreatePosts />}
              />

              <Route path="/create/" element={<SelectPostAssets />} />
              <Route path="/create/select" element={<SelectPostType />} />
              <Route path="/lead/assets/" element={<LeadAssets />} />
              <Route path="/create/house" element={<CreateHouse />} />
              <Route path="/edit/house/:id" element={<EditHouse />} />
              <Route path="/create/condo" element={<CreateCondo />} />
              <Route path="/edit/condo/:id" element={<EditCondo />} />
              <Route path="/create/commercial" element={<CreateCommercial />} />
              <Route path="/edit/commercial/:id" element={<EditCommercial />} />
              <Route path="/create/land" element={<CreateLand />} />
              <Route path="/edit/land/:id" element={<EditLand />} />
              <Route path="/create/townhouse" element={<CreateTownHouse />} />
              <Route path="/edit/townhouse/:id" element={<EditTownHouse />} />
              <Route path="/create/others" element={<CreateOtherPost />} />

              <Route path="/aunity/" element={<AunityRedirect />} />
              <Route path="/contact/customer" element={<ContactCustomerAsset />} />

              {/* Postperty */}
              <Route path="/help/postperty" element={<HelpSellPostperty />} />
            </Routes>
            </TokenManager>
          </Router>
        </CookiesProvider>
        </GalleryProvider>
      </ControlStateGMapAndGrid>
    </div>
  );
}

export default App;
